import {
  FileText,
  Image as ImageIcon,
  RefreshCw,
  Database,
  Type,
  Palette,
  Calculator,
  Zap,
  Shield,
  PenTool,
  Briefcase,
  Compass,
} from 'lucide-react';
import type { Category } from './types';

export const CATEGORIES: Category[] = [
  {
    id: 'documents',
    name: 'Documents',
    description: 'PDF, OCR, e-sign, redaction, comparison',
    icon: FileText,
    gradient: 'from-rose-400 to-orange-400',
    tint: '#fb7185',
  },
  {
    id: 'images',
    name: 'Images & Media',
    description: 'Resize, compress, convert, watermark, upscale',
    icon: ImageIcon,
    gradient: 'from-pink-400 to-rose-500',
    tint: '#f472b6',
  },
  {
    id: 'converters',
    name: 'Universal converters',
    description: 'Documents, data, audio, archives — anything to anything',
    icon: RefreshCw,
    gradient: 'from-fuchsia-400 to-pink-500',
    tint: '#e879f9',
  },
  {
    id: 'data',
    name: 'Spreadsheets & Data',
    description: 'CSV/Excel transforms, deduplication, charting',
    icon: Database,
    gradient: 'from-lime-400 to-yellow-500',
    tint: '#a3e635',
  },
  {
    id: 'text',
    name: 'Text & Developer',
    description: 'JSON, regex, base64, diff, hash, encoders',
    icon: Type,
    gradient: 'from-stone-500 to-stone-700',
    tint: '#78716c',
  },
  {
    id: 'color',
    name: 'Color & Design',
    description: 'Palettes, gradients, contrast, conversions',
    icon: Palette,
    gradient: 'from-rose-400 to-pink-500',
    tint: '#fb7185',
  },
  {
    id: 'calculators',
    name: 'Calculators & Conversions',
    description: 'Units, currency, EMI, ROI, dates, ratios',
    icon: Calculator,
    gradient: 'from-yellow-400 to-amber-500',
    tint: '#fbbf24',
  },
  {
    id: 'tiny',
    name: 'Tiny generators',
    description: 'QR, password, UUID, lorem, mock data',
    icon: Zap,
    gradient: 'from-amber-400 to-orange-500',
    tint: '#fb923c',
  },
  {
    id: 'security',
    name: 'Security & Privacy',
    description: 'Encrypt, hash, JWT, metadata scrubbing',
    icon: Shield,
    gradient: 'from-red-500 to-rose-700',
    tint: '#ef4444',
  },
  {
    id: 'writing',
    name: 'Writing & Intelligence',
    description: 'Markdown, summarize, count, format, transcription',
    icon: PenTool,
    gradient: 'from-orange-400 to-red-500',
    tint: '#fb923c',
  },
  {
    id: 'operations',
    name: 'Workplace operations',
    description: 'Invoices, expenses, signatures, SOPs',
    icon: Briefcase,
    gradient: 'from-emerald-400 to-lime-500',
    tint: '#34d399',
  },
  {
    id: 'browser',
    name: 'Browser utilities',
    description: 'Tabs, bookmarks, screenshot, web tools',
    icon: Compass,
    gradient: 'from-orange-300 to-amber-500',
    tint: '#fdba74',
  },
];

export const CATEGORY_BY_ID = Object.fromEntries(
  CATEGORIES.map((c) => [c.id, c]),
) as Record<string, Category>;
